import React from 'react'
import Helmet from 'react-helmet'

import Layout from 'landing/components/Layout'
import Header from 'landing/components/LandingHeader'
import Footer from 'landing/components/Footer'
import {Box, Flex, TextBox} from 'landing/kit'
import {
  Page,
  IntroBlock,
  Video
} from 'landing/components/about'

import {H2} from "landing/components/home/styles";
import {ClientsBlock, DemoBlock, WordsAboutBlock} from 'landing/components/home';

const About = ({ location }) => {

  return (
    <Layout>
      <Helmet>
        <link rel="canonical" href="https://pitchme.co/me/about" />
        <title>HR Recruiting Software: Automated Candidate Sourcing, Database Enrichment, Look-A-Like Search | PitchMe</title>
        <meta
          name="description"
          content="We automate sourcing, updating and shortlisting candidates to help recruiters find the best talent up to
                80% faster. Our ATS integration automatically keeps candidate information up-to-date, enriches profiles
                with skills and experience from 30+ sources, and identifies the right people for the role."
        />
      </Helmet>
      <Header location={location} />
      <Page>
        <IntroBlock />
        <Box py={{xs: 56, lg: 56}} css={{background: '#F1F1F1', marginTop: '-180px', marginBottom: '-60px'}}>
          <Box maxWidth={1137} width="100%" mx="auto" px={{xs: 24, lg: 0}}>
            <H2 fontWeight={800} color="secondaryLight" mb={{xs: 32, lg: 22}} mx="auto">
              What we do
            </H2>
            <VideoSection>
              <Box mr={{xs: 0, lg: 47}} css={{maxWidth: 600}}>
                <H2 fontWeight={800} color="#9255FA" mb={16}>Database Enrichment</H2>
                <TextBox fontSize={24} lineHeight={1.3} color="secondaryLight"  mb={{xs: 40, lg: 0}}>
                  Our AI solution uncovers hidden talent in your database by searching 30+ sources and updating your CRM
                  with detailed verified skills, experience and contact details.
                </TextBox>
              </Box>
              <Video src="https://pitchme-cdn.s3.eu-west-2.amazonaws.com/landing/Enrichment.mp4" />
            </VideoSection>

            <VideoSection isReverse={true}>
              <Video src="https://pitchme-cdn.s3.eu-west-2.amazonaws.com/landing/Sourcing.mp4"/>
              <Box ml={{xs: 0, lg: 47}} css={{maxWidth: 600}}>
                <H2 fontWeight={800} color="#9255FA" mb={16}>Automated Candidate Sourcing</H2>
                <TextBox fontSize={24} lineHeight={1.3} color="secondaryLight" mb={{xs : 40, lg : 0}}>
                  Our all-in-one recruitment tool sources high-quality talent from a broad range of quality sources. It
                  finds the most relevant candidates and matches them to your open roles. And it automatically adds
                  detailed profiles to your ATS with up-to-date skills, experience and contact details.
                </TextBox>
              </Box>
            </VideoSection>

            <VideoSection>
              <Box mr={{xs: 0, lg: 47}} css={{maxWidth: 600}}>
                <H2 fontWeight={800} color="#9255FA" mb={16}>Look-A-Like Search</H2>
                <TextBox fontSize={24} lineHeight={1.3} color="secondaryLight"  mb={{xs : 40, lg : 0}}>
                  Our smart AI delivers candidates that match the perfect profile of your client. By uploading a CV or
                  LinkedIn profile, you can receive a ready-to-call list of lookalike candidates with detailed skills,
                  experience and contact details in seconds.
                </TextBox>
              </Box>
              <Video src="https://pitchme-cdn.s3.eu-west-2.amazonaws.com/landing/Sourcing.mp4"/>
            </VideoSection>
          </Box>
          <Box maxWidth={1137} width="100%" mx="auto" px={{xs : 24, lg : 0}}>
            <H2 fontWeight={800} color="secondaryLight" mt={40} mb={{xs : 32, lg : 60}} mx="auto">
              What our clients say
            </H2>
          </Box>
          <WordsAboutBlock hideHeader={true}/>
          <ClientsBlock />
          <DemoBlock />
        </Box>
      </Page>
      <Footer />
    </Layout>
  )
}

export default About


const VideoSection = ({children, isReverse}) => (
  <Flex
    flexDirection={{xs : isReverse ? 'column-reverse' : 'column', lg : 'row'}}
    alignItems="center"
    px={{xs : 38, lg : 67}}
    py={{xs : 38, lg : 85}}
    css={{background : 'white', borderRadius : 32}}
    mb={{xs : 110, lg : 68}}
  > {children}</Flex>
)
